import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "windowsContainer",
    "emptyState",
    "copyAnchor",
    "rowTemplate",
    "copyMenuTemplate",
  ];

  connect() {
    console.log("[availability-builder] connected", this.element);
    console.log("[availability-builder] targets found:", {
      windowsContainers: this.windowsContainerTargets.length,
      emptyStates: this.emptyStateTargets.length,
      copyAnchors: this.copyAnchorTargets.length,
      hasRowTemplate: this.hasRowTemplateTarget,
      hasCopyMenuTemplate: this.hasCopyMenuTemplateTarget,
    });
    this.nextIndex =
      this.element.querySelectorAll("[data-window-row]").length;
    console.log("[availability-builder] nextIndex:", this.nextIndex);
    this._boundOutsideClick = this._handleOutsideClick.bind(this);
    document.addEventListener("click", this._boundOutsideClick);
  }

  disconnect() {
    document.removeEventListener("click", this._boundOutsideClick);
  }

  addWindow(event) {
    console.log("[availability-builder] addWindow fired", event);
    console.log("[availability-builder] event.params:", event.params);
    const dayStr = String(event.params.day);
    console.log("[availability-builder] day:", dayStr);

    const container = this._containerForDay(dayStr);
    console.log("[availability-builder] container:", container);
    if (!container) {
      console.error("[availability-builder] no container found for day", dayStr);
      return;
    }

    const row = this._buildRow(dayStr);
    console.log("[availability-builder] built row:", row);
    container.appendChild(row);
    this._updateDayState(dayStr);

    const startInput = row.querySelector("[data-start-field]");
    if (startInput) startInput.focus();
    console.log("[availability-builder] addWindow complete");
  }

  removeWindow(event) {
    const row = event.currentTarget.closest("[data-window-row]");
    if (!row) return;

    const dayField = row.querySelector("[data-day-field]");
    const day = dayField ? dayField.value : null;
    row.remove();
    if (day) this._updateDayState(day);
  }

  toggleCopyMenu(event) {
    event.stopPropagation();
    const dayStr = String(event.params.day);

    const existingMenu = this.element.querySelector(
      "[data-copy-menu-active]"
    );
    if (existingMenu) {
      const wasSameDay = existingMenu.dataset.sourceDay === dayStr;
      existingMenu.remove();
      if (wasSameDay) return;
    }

    const menu = this.copyMenuTemplateTarget.cloneNode(true);
    menu.removeAttribute("data-availability-builder-target");
    menu.setAttribute("data-copy-menu-active", "true");
    menu.dataset.sourceDay = dayStr;
    menu.classList.remove("hidden");

    const sourceLabel = menu.querySelector(`[data-copy-day="${dayStr}"]`);
    if (sourceLabel) sourceLabel.closest("label").remove();

    const anchor = event.currentTarget.closest(
      "[data-availability-builder-target='copyAnchor']"
    );
    if (anchor) anchor.appendChild(menu);
  }

  applyCopy(event) {
    event.stopPropagation();

    const menu = event.currentTarget.closest("[data-copy-menu-active]");
    if (!menu) return;

    const sourceDay = menu.dataset.sourceDay;
    const targetDays = [
      ...menu.querySelectorAll("input[type=checkbox]:checked"),
    ].map((cb) => cb.value);

    if (targetDays.length === 0) {
      menu.remove();
      return;
    }

    const sourceContainer = this._containerForDay(sourceDay);
    const sourceWindows = sourceContainer
      ? [...sourceContainer.querySelectorAll("[data-window-row]")].map(
          (row) => ({
            start: row.querySelector("[data-start-field]").value,
            end: row.querySelector("[data-end-field]").value,
          })
        )
      : [];

    targetDays.forEach((targetDay) => {
      const targetContainer = this._containerForDay(targetDay);
      if (!targetContainer) return;

      targetContainer
        .querySelectorAll("[data-window-row]")
        .forEach((r) => r.remove());

      sourceWindows.forEach((w) => {
        const row = this._buildRow(targetDay);
        row.querySelector("[data-start-field]").value = w.start;
        row.querySelector("[data-end-field]").value = w.end;
        targetContainer.appendChild(row);
      });

      this._updateDayState(targetDay);
    });

    menu.remove();
  }

  // ── Private ──

  _containerForDay(day) {
    return this.windowsContainerTargets.find(
      (el) => el.dataset.day === String(day)
    );
  }

  _emptyStateForDay(day) {
    return this.emptyStateTargets.find(
      (el) => el.dataset.day === String(day)
    );
  }

  _copyAnchorForDay(day) {
    return this.copyAnchorTargets.find(
      (el) => el.dataset.day === String(day)
    );
  }

  _buildRow(day) {
    const fragment = this.rowTemplateTarget.content.cloneNode(true);
    const row = fragment.querySelector("[data-window-row]");
    const idx = this.nextIndex++;

    row.querySelectorAll("input").forEach((input) => {
      if (input.name) input.name = input.name.replace(/INDEX/g, idx);
    });
    row.querySelector("[data-day-field]").value = day;

    return row;
  }

  _updateDayState(day) {
    const container = this._containerForDay(day);
    if (!container) return;

    const hasRows =
      container.querySelectorAll("[data-window-row]").length > 0;
    const emptyState = this._emptyStateForDay(day);
    const copyAnchor = this._copyAnchorForDay(day);

    if (emptyState) {
      emptyState.classList.toggle("hidden", hasRows);
    }
    if (copyAnchor) {
      copyAnchor.classList.toggle("invisible", !hasRows);
    }
  }

  _handleOutsideClick(event) {
    const menu = this.element.querySelector("[data-copy-menu-active]");
    if (!menu) return;

    if (
      !menu.contains(event.target) &&
      !event.target.closest(
        "[data-action*='availability-builder#toggleCopyMenu']"
      )
    ) {
      menu.remove();
    }
  }
}
